import { View } from "@src/components";
import { Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { PressableScale } from "pressto";
import { memo, useCallback, useMemo } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { useRouter } from "expo-router";
import type { Site } from "@src/features/settings/data/mock-sites";

type SiteAccessListItemProps = {
  site: Site;
};

export const SiteAccessListItem = memo(({ site }: SiteAccessListItemProps) => {
  const { theme } = useUnistyles();
  const router = useRouter();
  const managers = useMemo(() => site.users.filter((user) => user.role === "manager"), [site.users]);
  const viewers = useMemo(() => site.users.filter((user) => user.role === "viewer"), [site.users]);

  const handleNavigateToSiteAccess = useCallback(() => {
    router.push(`/settings/site-access/${site.id}`);
  }, [router, site.id]);

  return (
    <PressableScale onPress={handleNavigateToSiteAccess}>
      <View bg="surfaceCard" flexDirection="row" justifyContent="space-between" style={styles.container}>
        <View gap="xs">
          <Text textStyle="sm/medium">{site.name || site.id}</Text>
          <View flexDirection="row" alignItems="center" gap="xs">
            <Text textStyle="xs/regular" color="textMuted">
              {managers.length} {managers.length === 1 ? "manager" : "managers"}
            </Text>
            <Text textStyle="xs/regular" color="textMuted">
              •
            </Text>
            <Text textStyle="xs/regular" color="textMuted">
              {viewers.length} {viewers.length === 1 ? "viewer" : "viewers"}
            </Text>
          </View>
        </View>
        <Icon name="chevronRight" size={theme.spacing["6xl"]} color={theme.colors.iconPrimary} />
      </View>
    </PressableScale>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    paddingVertical: theme.spacing["3xl"],
    paddingHorizontal: theme.spacing.xl,
    borderRadius: theme.spacing.md,
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
  },
}));
